import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div className="page page-center">
      <div className="placeholder-card">
        <div className="placeholder-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="m4.9 4.9 14.2 14.2" />
          </svg>
        </div>
        <h1>Pagina non trovata</h1>
        <p><Link to="/" className="btn-primary">Torna alla home</Link></p>
      </div>
    </div>
  )
}

export default NotFound
